import { Component } from '@angular/core';

interface NewsItem {
    image: string;
    category: string;
    author: string;
    comments: number;
    title: string;
    route: string;
    featured: boolean;
}

@Component({
    selector: 'app-news-list-redesign',
    templateUrl: './news-list-redesign.component.html',
    styleUrls: ['./news-list-redesign.component.scss']
})
export class NewsListRedesignComponent {

    articles: NewsItem[] = [
        {
            image: '/assets/img/redesign/news/stand01.jpg',
            category: 'Category',
            author: 'Usuario',
            comments: 3,
            title: 'FENS 2026',
            route: '/news-redesign/fens-2026',
            featured: false
        },
        // {
        //     image: '/assets/img/redesign/news/news.png',
        //     category: 'Category',
        //     author: 'Usuario',
        //     comments: 3,
        //     title: 'IT Service Case Studies Accelerate Business Fly Success Tech',
        //     route: '/news-redesign/fens-2026',
        //     featured: true
        // },
        // {
        //     image: '/assets/img/redesign/news/news.png',
        //     category: 'Category',
        //     author: 'Usuario',
        //     comments: 3,
        //     title: 'IT Service Case Studies Accelerate Business Fly Success Tech',
        //     route: '/news-redesign/fens-2026',
        //     featured: false
        // },
        // {
        //     image: '/assets/img/redesign/news/news.png',
        //     category: 'Category',
        //     author: 'Usuario',
        //     comments: 3,
        //     title: 'IT Service Case Studies Accelerate Business Fly Success Tech',
        //     route: '/news-redesign/fens-2026',
        //     featured: false
        // },
        // {
        //     image: '/assets/img/redesign/news/news.png',
        //     category: 'Category',
        //     author: 'Usuario',
        //     comments: 3,
        //     title: 'IT Service Case Studies Accelerate Business Fly Success Tech',
        //     route: 'news-redesign/fens-2026',
        //     featured: true
        // },
        // {
        //     image: '/assets/img/redesign/news/news.png',
        //     category: 'Category',
        //     author: 'Usuario',
        //     comments: 3,
        //     title: 'IT Service Case Studies Accelerate Business Fly Success Tech',
        //     route: 'news-redesign/fens-2026',
        //     featured: false
        // }
    ];

    trackByTitle(index: number, article: NewsItem): string {
        return article.title;
    }

}